import { prefersReducedMotion } from '../../styles/motion'
import { tokens } from '../../styles/tokens'

// Motion for the moment a week is met, timed off the app's motion tokens. Everything runs through
// the Web Animations API so it needs no global CSS, and it all stands down under
// prefers-reduced-motion (the state still changes; it just doesn't move).

const ms = (duration: string) => parseInt(duration, 10)

export const DURATION = {
    fast: ms(tokens.motion.fast),
    base: ms(tokens.motion.base),
    slow: ms(tokens.motion.slow),
}
export const EASE_OUT = tokens.motion.easeOut

/** The week's day pills turn green one after another, left to right, this far apart. */
export const WAVE_STEP = 40
/** When the wave starts, after the new day has popped. */
export const WAVE_DELAY = DURATION.base + 60

export { prefersReducedMotion }

/** The small overshoot a day pill makes when it fills. */
export const pop = (element: HTMLElement, delay = 0) => {
    if (prefersReducedMotion()) return
    element.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.18)' }, { transform: 'scale(1)' }], {
        duration: DURATION.slow,
        delay,
        easing: EASE_OUT,
    })
}

const CONFETTI_COLORS = ['#479c4d', '#6b5ba8', '#f7db4a', '#2f6e9f', '#cd9c1f']

/**
 * A short burst of confetti from the middle of `anchor`, cleaned up when it lands. `scale` grows it
 * for the bigger moment: a met week is 1, achieving a whole goal is louder.
 */
export const burstConfetti = (anchor: HTMLElement, scale = 1) => {
    if (prefersReducedMotion()) return
    const rect = anchor.getBoundingClientRect()
    const layer = document.createElement('div')
    layer.setAttribute('aria-hidden', 'true')
    Object.assign(layer.style, { position: 'fixed', inset: '0', pointerEvents: 'none', zIndex: '1000' })
    document.body.appendChild(layer)

    const pieces = Math.round(36 * scale)
    const animations = Array.from({ length: pieces }, (_, index) => {
        const piece = document.createElement('span')
        const size = 4 + Math.random() * 4
        // Spread the launch points across the row, and fan the pieces upward and out.
        const startX = rect.left + Math.random() * rect.width
        const startY = rect.top + rect.height / 2
        const angle = (-90 + (Math.random() - 0.5) * 110) * (Math.PI / 180)
        const speed = (60 + Math.random() * 90) * Math.sqrt(scale)
        const dx = Math.cos(angle) * speed
        const dy = Math.sin(angle) * speed
        const spin = (Math.random() - 0.5) * 720
        Object.assign(piece.style, {
            position: 'absolute',
            left: `${startX}px`,
            top: `${startY}px`,
            width: `${size}px`,
            height: `${size * (index % 3 === 0 ? 1 : 0.45)}px`,
            borderRadius: index % 3 === 0 ? '999px' : '1px',
            background: CONFETTI_COLORS[index % CONFETTI_COLORS.length],
        })
        layer.appendChild(piece)
        return piece.animate(
            [
                { transform: 'translate(0, 0) rotate(0deg)', opacity: 1 },
                { transform: `translate(${dx}px, ${dy}px) rotate(${spin / 2}deg)`, opacity: 1, offset: 0.35 },
                { transform: `translate(${dx * 1.3}px, ${dy + 140}px) rotate(${spin}deg)`, opacity: 0 },
            ],
            { duration: 900 + Math.random() * 400, easing: 'cubic-bezier(0.2, 0.6, 0.4, 1)', fill: 'forwards' }
        ).finished
    })
    Promise.allSettled(animations).then(() => layer.remove())
}
